import { ThreeDimensionalLight } from 'survey-core/themes';

export const surveyJSON = {
    "title": "MyMedsPh Feedback Survey",
    "description": "Your opinion matters to us!",
    "logo": "assets/img/brand/mymeds-logo-full.svg",
    "logoHeight": "72px",
    "headerView": "advanced",
    "allowHtml": true,
    "pages": [
        {
            "name": "page1",
            "elements": [
                {
                    "type": "radiogroup",
                    "name": "system-usage",
                    "title": "How often do you use the system?",
                    "choices": [
                        "Every Day, multiple times",
                        "Every workday, atleast once",
                        "A few times a week",
                        "Less than once a week",
                        "I've only used it once"
                    ],
                    "isRequired": true,
                },
                {
                    "type": "checkbox",
                    "name": "system-usage-features",
                    "title": "What features have you used the most?",
                    "description": "(Select all that apply)",
                    "choices": [
                        "Calendar & Scheduling",
                        "Patient Records",
                        "Progress Notes",
                        "Treatment Plans",
                        "Billing & Payments",
                        "Charting",
                        "Online Booking",
                        "Prescriptions",
                        "Certifications",
                        "Expense Tracking",
                        "Patient Consent / Shared Forms",
                        "SMS Scheduling",
                        "Follow-up Management",
                        "Other"
                    ],
                    "isRequired": true,
                   
                  
                },
                {
                    "type": "rating",
                    "name": "satisfaction-experience",
                    "title": "How satisfied are you with the system overall?",
                    "isRequired": true,
                    "rateCount": 5,
                    "rateMax": 5,
                    "rateMin": 1,
                    "rateStep": 1,
                    "rateType": "smileys",
                    "rateValues": [
                        {"value": 1, "text": "Very dissatisfied",},
                        {"value": 2, "text": "Somewhat dissatisfied"},
                        {"value": 3, "text": "Neutral"},
                        {"value": 4, "text": "Somewhat satisfied"},
                        {"value": 5, "text": "Very satisfied"}
                    ]
                  
                },
                {
                    "type": "rating",
                    "name": "satisfaction-experience-2",
                    "title": "How easy is it to perform your daily tasks using the system?",
                    "isRequired": true,
                    "rateCount": 5,
                    "rateMax": 5,
                    "rateMin": 1,
                    "rateStep": 1,
                    "rateType": "smileys",
                    "rateValues": [
                        {"value": 1, "text": "Very difficult"},
                        {"value": 2, "text": "Somewhat difficult"},
                        {"value": 3, "text": "Neutral"},
                        {"value": 4, "text": "Somewhat easy"},
                        {"value": 5, "text": "Very easy"}
                    ]
                  
                },
   
                {
                    "type": "rating",
                    "name": "satisfaction-experience-3",
                    "title": "How helpful is the dental management system in your daily tasks?",
                    "isRequired": true,
                    "rateType": "smileys",
                    "rateCount": 5,
                    "rateMax": 5,
                    "rateMin": 1,
                    "rateValues": [
                        {"value": 1, "text": "Not Helpful at all for me"},
                        {"value": 2, "text": "Not Helpful for me"},
                        {"value": 3, "text": "It's Somewhat Helpful for me"},
                        {"value": 4, "text": "Somewhat Helpful for me"},
                        {"value": 5, "text": "Very Helpful for me"}
                    ]
                },
                {
                    "type": "comment",
                    "name": "satisfaction-experience-4",
                    "title": "Can you tell us more about how MyMeds impacted you workflow?",
                    "isRequired": false,
                    "placeholder": "Please share your thoughts..."
                },
                {
                    "type": "rating",
                    "name": "satisfaction-experience-5",
                    "title": "How likely are you to recommend the system to a colleague or friend?",
                    "isRequired": true,
                    "rateType": "smileys",
                    "rateCount": 5,
                    "rateMax": 5,
                    "rateMin": 1,
                    "rateValues": [
                        {"value": 1, "text": "Very unlikely"},
                        {"value": 2, "text": "Somewhat unlikely"},
                        {"value": 3, "text": "Neutral"},
                        {"value": 4, "text": "Somewhat likely"},
                        {"value": 5, "text": "Very likely"}
                    ]
                },
                {
                    "type": "rating",
                    "name": "satisfaction-experience-6",
                    "title": "Does the system show information quickly when you open a page?",
                    "isRequired": true,
                    "rateType": "smileys",
                    "rateCount": 5,
                    "rateMax": 5,
                    "rateMin": 1,
                    "rateValues": [
                        {"value": 1, "text": "It takes far too long to load"},
                        {"value": 2, "text": "It often takes quite a while"},
                        {"value": 3, "text": "Sometimes it takes a bit of time"},
                        {"value": 4, "text": "Yes, it loads within a few seconds"},
                        {"value": 5, "text": "Yes, the information appears right away"}
                    ]
                },
              
                {
                    "type": "comment",
                    "name": "satisfaction-experience-7",
                    "title": "What would you like to see improved in the system?",
                    "isRequired": false,
                    "placeholder": "Please share your thoughts..."
                },
                {
                    "type": "comment",
                    "name": "satisfaction-experience-8",
                    "title": "Which feature(s) do you find frustrating or rarely use? Why?",
                    "isRequired": false,
                    "placeholder": "Please share your thoughts..."
                }
            ]
        },
        {
            "name": "page2",
            "elements": [
                {
                    "type": "matrix",
                    "name": "feature-ratings",
                    "title": "Feature-Specific Feedback for each feature below, rate your experience",
                    "description": "(1 = Poor, 5 = Excellent)",
                   
                    "columns": [
                        {"value": 1, "text": "1"},
                        {"value": 2, "text": "2"},
                        {"value": 3, "text": "3"},
                        {"value": 4, "text": "4"},
                        {"value": 5, "text": "5"}
                    ],
                    "rows": [
                        {"value": "calendar-scheduling", "text": "Calendar & Scheduling"},
                        {"value": "online-booking", "text": "Online Booking"},
                        {"value": "patient-records", "text": "Patient Records"},
                        {"value": "progress-notes", "text": "Progress Notes"},
                        {"value": "treatment-plans", "text": "Treatment Plans"},
                        {"value": "billing-payment", "text": "Billing & Payment"},
                        {"value": "charting", "text": "Charting"},
                        {"value": "scheduled-followups", "text": "Scheduled Follow-ups"},
                        {"value": "sms-scheduling", "text": "SMS Scheduling"},
                        {"value": "patient-consents", "text": "Patient Consents / Form Sharing"},
                        {"value": "prescriptions", "text": "Prescriptions"},
                        {"value": "certifications", "text": "Certifications"},
                        {"value": "expense-tracking", "text": "Expense Tracking"},
                        {"value": "shared-forms", "text": "Shared Forms"}
                    ],
                    "eachRowRequired": true
                },
                {
                    "type": "rating",
                    "name": "system-reliability",
                    "title": "How would you rate the reliability of the system(Speed,uptime,error-free use)?",
                    "isRequired": true,
                    "rateCount": 5,
                    "rateMax": 5,
                    "rateMin": 1,
                    "rateStep": 1,
                    "rateType": "stars",
                    "rateMaxDescription": "Very reliable",
                    "rateMinDescription": "Very unreliable"
                  
                },
                {
                    "type": "text",
                    "name": "mymeds-system-save-time",
                    "title": "How else could MyMeds help you make your work easier and save time?",
                    "description": "(If there is none, please type 'N/A')",
                    "isRequired": true,
                    "placeholder": "Please share your thoughts..."
                },
                {
                    "type": "text",
                    "name": "mymeds-system-unnecessary-parts-to-use",
                    "title": "Are there parts of the system that feel hard to use or unnecessary for work?",
                    "description": "if yes, why? (required, if there is none, please type 'N/A')",
                    "isRequired": true,
                    "placeholder": "Please describe the features..."
                },
                {
                    "type": "radiogroup",
                    "name": "beta-testing",
                    "title": "Would you be open to testing early beta features and giving feedback?",
                    "choices": [
                        "Yes",
                        "No"
                    ],
                    "isRequired": true
                },
                {
                    "type": "comment",
                    "name": "final-thoughts",
                    "title": "Feel free to leave any comments, thoughts or further suggestion in the box below.",
                    "isRequired": false,
                    "placeholder": "We value your feedback..."
                }
            ]
        }
    ],
    "showProgressBar": true,
    "progressBarType": "pages",
    "widthMode": "responsive"
};

const mmpSurveyThemeBaseVariables = {
    ...ThreeDimensionalLight.cssVariables,
    '--sjs-font-family': 'Inter, system-ui, sans-serif',
    '--sjs-corner-radius': '8px',
    '--sjs-base-unit': '8px',
    '--sjs-primary-backcolor': '#2f5189',
    '--sjs-primary-backcolor-dark': '#244374',
    '--sjs-primary-backcolor-light': 'rgba(47, 81, 137, 0.12)',
    '--sjs-primary-forecolor': '#ffffff',
    '--sjs-secondary-backcolor': '#f59120',
    '--sjs-secondary-backcolor-light': 'rgba(245, 145, 32, 0.12)',
    '--sjs-special-red': '#d63b55',
    '--sjs-shadow-small': '0 1px 3px rgba(15, 23, 42, 0.08)',
    '--sjs-shadow-medium': '0 4px 12px rgba(15, 23, 42, 0.1)'
};

/** SurveyJS theme aligned with MMP dashboard / settings design tokens (light). */
export const mmpSurveyTheme = {
    ...ThreeDimensionalLight,
    colorPalette: 'light' as const,
    cssVariables: {
        ...mmpSurveyThemeBaseVariables,
        '--sjs-general-backcolor': '#f4f6fa',
        '--sjs-general-backcolor-dim': '#ffffff',
        '--sjs-general-forecolor': '#1d2125',
        '--sjs-general-forecolor-light': '#626f86',
        '--sjs-general-dim-forecolor': '#1d2125',
        '--sjs-general-dim-forecolor-light': '#626f86',
        '--sjs-font-surveytitle-color': '#1d2125',
        '--sjs-font-surveydescription-color': '#626f86',
        '--sjs-font-headerdescription-color': '#626f86',
        '--sjs-font-pagedescription-color': '#626f86',
        '--sjs-font-headertitle-color': '#1d2125',
        '--sjs-font-questiondescription-color': '#626f86',
        '--sjs-border-default': '#dde5ee',
        '--sjs-border-light': '#edf1f5'
    }
};

/** Build SurveyJS theme for the active app color mode (SurveyJS does not resolve CSS var() from html). */
export function buildMmpSurveyTheme(isDarkMode: boolean) {
    if (!isDarkMode) {
        return mmpSurveyTheme;
    }

    return {
        ...ThreeDimensionalLight,
        colorPalette: 'dark' as const,
        cssVariables: {
            ...mmpSurveyThemeBaseVariables,
            '--sjs-general-backcolor': '#202838',
            '--sjs-general-backcolor-dim': '#171d29',
            '--sjs-general-forecolor': '#eef3fb',
            '--sjs-general-forecolor-light': '#9aa9c0',
            '--sjs-general-dim-forecolor': '#eef3fb',
            '--sjs-general-dim-forecolor-light': '#9aa9c0',
            '--sjs-font-surveytitle-color': '#eef3fb',
            '--sjs-font-surveydescription-color': '#9aa9c0',
            '--sjs-font-headerdescription-color': '#9aa9c0',
            '--sjs-font-pagedescription-color': '#9aa9c0',
            '--sjs-font-headertitle-color': '#eef3fb',
            '--sjs-font-questiondescription-color': '#9aa9c0',
            '--sjs-border-default': '#334057',
            '--sjs-border-light': '#283346',
            '--sjs-shadow-small': '0 1px 3px rgba(0, 0, 0, 0.35)',
            '--sjs-shadow-medium': '0 4px 12px rgba(0, 0, 0, 0.4)'
        }
    };
}
